// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum DeviceErrorSortKey {
	LastOccurrence = 0,
	HashId = 1,
	LatestFirmware = 2,
	Count = 3,
	FirstOccurrence = 4,
	Status = 5,
	Count24h = 6,
	Count7d = 7,
	Message = 8,
}

export const DeviceErrorSortKeyDisplayNames: { [key in keyof typeof DeviceErrorSortKey]?: string} = {
	"LastOccurrence": "LastOccurrence",
	0 : "LastOccurrence",
	"HashId": "HashId",
	1 : "HashId",
	"LatestFirmware": "LatestFirmware",
	2 : "LatestFirmware",
	"Count": "Count",
	3 : "Count",
	"FirstOccurrence": "FirstOccurrence",
	4 : "FirstOccurrence",
	"Status": "Status",
	5 : "Status",
	"Count24h": "Count24h",
	6 : "Count24h",
	"Count7d": "Count7d",
	7 : "Count7d",
	"Message": "Message",
	8 : "Message",
}

export const getDeviceErrorSortKeyDisplayName = (key: DeviceErrorSortKey | (keyof typeof DeviceErrorSortKey & string)) => {
	return DeviceErrorSortKeyDisplayNames[key];
}

